import React from "react";

export default function CallChatSection() {
  return (
    <section className="subscribe-area subscribe-area-2 text-center">
      <div className="container">
        <div className="row bg-gradent">
          <div className="col-md-12 col-sm-6 col-xs-12 subscribe-title-box">
            <div className="subscribe-title">
              <h2>
                Call <a href="tel:9894148948">9894148948</a> or{" "}
                <a
                  href="https://wa.me/9894148948"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Whatsapp 24 X 7
                </a>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
